export class AssertionError extends Error {}

export function assert(condition: boolean, message: string): asserts condition {
  if (!condition) {
    throw new AssertionError(message)
  }
}

export function assertNotNull(value: unknown, message: string): asserts value is NonNullable<unknown> {
  return assert(value != null, message)
}

export function assertPositive(value: any, message: string): void {
  return assert(value > 0, message)
}

export function assertIncludes<T>(value: T, array: T[], message: string): void {
  return assert(array.includes(value), message)
}
